import { ROUTE_NAMES } from '../constants';
import { RouterUrl } from './routes';

export const getRouteFromStepName = (step: string) => {
  switch (step) {
    case ROUTE_NAMES.Registration:
      return RouterUrl.Registration;
    case ROUTE_NAMES.RegistrationType:
      return RouterUrl.RegistrationType;
    case ROUTE_NAMES.AutoPhotoFrontDNI:
      return RouterUrl.QuickRegistrationFrontDNI;
    case ROUTE_NAMES.AutoPhotoBackDNI:
      return RouterUrl.QuickRegistrationBackDNI;
    case ROUTE_NAMES.EditFrontDNI:
      return RouterUrl.FrontalDNI;
    case ROUTE_NAMES.EditBackDNI:
      return RouterUrl.ReversoDNI;
    case ROUTE_NAMES.PersonalInfo:
      return RouterUrl.PersonalWorkInfo;
    case ROUTE_NAMES.BankInfo:
      return RouterUrl.PaymentInfo;
    case ROUTE_NAMES.PhotoFrontDNI:
      return RouterUrl.PhotoFrontDNI;
    case ROUTE_NAMES.PhotoBackDNI:
      return RouterUrl.PhotoBackDNI;
    case ROUTE_NAMES.Selfie:
      return RouterUrl.Selfie;
    case ROUTE_NAMES.CreateFirstApplication:
      return RouterUrl.CreateApplicationPage;
    case ROUTE_NAMES.ResolvedFirstApplication:
      return RouterUrl.ApplicationConsideration;
    case ROUTE_NAMES.DocumentRequest:
      return RouterUrl.DocumentRequest;
    case ROUTE_NAMES.PersonalAccount:
      return RouterUrl.Account;
    case ROUTE_NAMES.WaitingApplicationDecision:
      return RouterUrl.ApplicationConsideration;
    case ROUTE_NAMES.AddCardOnRegistration:
      return RouterUrl.SigningAgreement;
    case ROUTE_NAMES.ConfirmApplication:
      return RouterUrl.SigningAgreement;
    // NOTE: for users under moratoirum
    case ROUTE_NAMES.BlockedUser:
      return RouterUrl.Account;
    default:
      return RouterUrl.Login;
  }
};
